import React, { PureComponent } from 'react';
import ShortId from 'shortid';
import PT from 'prop-types';
import { throttle, isPlainObject, isDate } from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import classNames from 'classnames';
import { SortTypes, SortHeader } from './SortHeader/SortHeader';
import dictionary from '../../../lib/dict.json';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { selectTracking } from '../../../store/reducers/tracking';
import { DESKTOP } from '../../../store/actions/browser.types';
import PlainTablePropTypes from './PlainTable.proptypes';
import classes from './DataTable.css';
import { selectTeamState } from '../../views/Team/module/team';

/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */

const mapStateToProps = state => ({
  collapsed: selectControlsState(state).collapsed,
  mediaType: state.browser.mediaType,
  tracking: selectTracking(state),
  currentFormula: selectTeamState(state).currentFormula,
  currentSeason: selectTeamState(state).currentSeason,
  selectedYear: selectTeamState(state).selectedYear,
});
export class ConnectedPlainTable extends PureComponent {
  static propTypes = {
    ...PlainTablePropTypes,
    initialSortColumn: PT.string,
    equalWidthCols: PT.bool,
    colWidths: PT.arrayOf(PT.string),
    disableSort: PT.bool,
    fixFirstColumn: PT.bool,
    toggleTeamStats: PT.bool,
  };
  static defaultProps = {
    language: 'en',
    data: [],
    colGroups: [
      {
        name: '',
        columns: [''],
        colLabels: [],
      },
    ],
    showTeamStats: [],
    initialSortColumn: 'FPTS',
    equalWidthCols: false,
    centerFirstCol: false,
    colWidths: [],
    disableSort: false,
    fixFirstColumn: true,
    tracking: {},
    sortAscending: true,
    sortFirstColumn: false,
    tableTitleFixed: false,
  };

  state = {
    colLabels: [],
    allColumns: [],
    currentSort: {},
    rows: [],
    nested: false,
    windowWidth: 0,
    scrollLeft: 0,
  };

  componentDidMount = () => {
    const { colGroups, initialSortColumn, data, disableSort, sortAscending } = this.props;
    const allColumns = [];
    this.fixedElements = [];
    let colLabels = [];
    // this.processMatrix(data, initialSortColumn);
    colGroups.forEach(group => {
      group.columns.forEach(col => allColumns.push(col));
      if (group.colLabels && group.colLabels.length) colLabels = colLabels.concat(group.colLabels);
      // colLabels = colLabels.concat(
      //   group.colLabels && group.colLabels.length ? group.colLabels : allColumns,
      // );
    });
    if (!colLabels || !colLabels.length) colLabels = allColumns;
    this.setState(
      { allColumns, rows: data, colLabels },
      () => !disableSort && this.sortRows(initialSortColumn, sortAscending ? SortTypes.ASC : SortTypes.DESC),
    );
    this.tableContainer.addEventListener(
      'scroll',
      throttle(this.handleScroll, 15),
    );
  };

  componentWillReceiveProps = newProps => {
    const allColumns = [];
    let colLabels = [];
    if (newProps.colGroups !== this.props.colGroups) {
      const { colGroups } = newProps;
      colGroups.forEach(group => {
        group.columns.forEach(col => allColumns.push(col));
        colLabels = group.colLabels && group.colLabels.length && colLabels.concat(group.colLabels);
      });
      if (!colLabels || !colLabels.length) colLabels = allColumns;
      this.setState({ allColumns, colLabels });
    }
    if (newProps.data !== this.props.data) {
      const { initialSortColumn, data, disableSort } = newProps;
      this.setState(
        { rows: data },
        () => !disableSort && this.sortRows(initialSortColumn, SortTypes.DESC),
      );
    }
  };

  componentDidUpdate = () => {
    requestAnimationFrame(() => {
      this.updateScrollPositions(this.scrollLeft);
    });

    // Changes colspan when stats are disabled
    const { toggleTeamStats } = this.props;
    const tableTitlesFirstColumn = document.getElementsByClassName('table-title')[0];
    if (typeof toggleTeamStats !== 'undefined' && typeof tableTitlesFirstColumn !== 'undefined') {
      toggleTeamStats === false
        ? tableTitlesFirstColumn.colSpan = 1
        : tableTitlesFirstColumn.colSpan = 2;
    }
  };

  addFixedElement = el => {
    el && this.fixedElements.push(el);
  };

  handleScroll = node => {
    this.scrollLeft = Number(node.target.scrollLeft.toFixed(1));
    requestAnimationFrame(() => {
      this.updateScrollPositions(this.scrollLeft);
    });
  };

  handleRubberBandEffect = () => {
    const tableContainer = document.querySelector('.tableContainer--fixed');
    const dataTableWidth = document.querySelector('.dataTable').offsetWidth;
    const tableContainerWidth = tableContainer.offsetWidth;
    const sLeft = tableContainer.scrollLeft;
    const scrollableArea = (dataTableWidth - tableContainerWidth) - 1;
    // Prevents Rubber Band Effect
    if (sLeft > scrollableArea) tableContainer.scrollLeft = sLeft - 1;
  }

  updateScrollPositions = scrollLeft => {
    const style = {
      transform: `translate3d(${scrollLeft}px,0px,5px)`,
      borderRight: '5px solid rgba(0, 0, 0, 0.1)',
      zIndex: 2,
    };

    const styleFirstFixedColumn = {
      position: 'sticky',
      transform: `translate3d(${scrollLeft}px,0px,5px)`,
      borderRight: '5px solid rgba(0, 0, 0, 0.1)',
      zIndex: 6,
    };

    const styleFixedColumn = {
      position: 'sticky',
      borderRight: '5px solid rgba(0, 0, 0, 0.1)',
      left: 0,
    };

    if (this.props.tableStatsFixed) {
      this.fixedElements.forEach(el => {
        el && Object.assign(el.parentElement.style, { ...styleFixedColumn }); // eslint-disable-line
      });
    } else if (this.props.sortFirstColumn) {
      this.fixedElements.forEach(el => {
        el && Object.assign(el.parentElement.style, { ...styleFirstFixedColumn }); // eslint-disable-line
      });
    } else {
      this.fixedElements.forEach(el => {
        el && Object.assign(el.parentElement.style, { ...style }); // eslint-disable-line
      });
    }
  };

  sortRows = (colKey, dir) => {
    const { rows } = this.state;
    if (!rows || !rows.length) return;
    const isObject = isPlainObject(rows[0][colKey]);
    const isDateObj = isDate((colKey === 'birthdate' && moment(rows[0][colKey])._d) || false);
    const key = colKey === 'name' ? 'fullName' : colKey;
    rows.sort((b, a) => {
      let sortVal = 0;
      const aVal = (isObject && a[key].sortValue) || a[key];
      const bVal = (isObject && b[key].sortValue) || b[key];
      if (isDateObj) {
        if (moment(a[key]).isBefore(b[key])) sortVal = 1;
        if (moment(a[key]).isAfter(b[key])) sortVal = -1;
      } else if (isNaN(aVal) && isNaN(bVal)) {
        if (aVal > bVal) sortVal = 1;
        if (aVal < bVal) sortVal = -1;
      } else {
        if (aVal > bVal || isNaN(bVal)) sortVal = 1;
        if (aVal < bVal || isNaN(aVal)) sortVal = -1;
      }
      if (sortVal !== 0 && dir === SortTypes.ASC) sortVal *= -1;
      return sortVal;
    });
    this.setState({ rows, currentSort: { [colKey]: dir } });
  };

  renderColGroups = () => {
    const { colGroups, teamColor, tableTitleFixed } = this.props;
    const teamColorStyle = teamColor && { backgroundColor: teamColor };
    // In order for titles to show, all groups must use the name prop, even if it is ''
    // If no name prop exists, we can assume this table has no title row
    if (!colGroups.length || typeof colGroups[0].name === 'undefined') {
      return null;
    }

    return (
      <Table.Header>
        <Table.Row>
          {colGroups.map(
            group =>
              group.name ? (
                <Table.HeaderCell
                  className={tableTitleFixed ? 'table-title table-title--sticky' : 'table-title'}
                  key={group.name}
                  colSpan={group.columns.length}
                  style={teamColorStyle}
                >
                  {group.name.toUpperCase()}
                </Table.HeaderCell>
              ) : null,
          )}
        </Table.Row>
      </Table.Header>
    );
  };

  renderColumnHeaders = () => {
    const {
      language,
      statColWidth,
      centerFirstCol,
      disableSort,
      fittedText,
      fixFirstColumn,
      sortFirstColumn,
    } = this.props;
    const { currentSort, colLabels, allColumns } = this.state;
    const colStyle = { maxWidth: statColWidth, padding: '3px' };
    return (
      <Table.Row>
        {colLabels.map((colLabel, colIndex) => {
          if (disableSort) {
            return this.renderStandardHeader({
              col: colLabel,
              language,
              colStyle: colIndex ? colStyle : null,
              isLeftAligned: !colIndex && !centerFirstCol,
              fixedHeader: (!colIndex && fixFirstColumn),
            });
          } else if (sortFirstColumn) {
            if (colIndex !== 0) {
              return this.renderStandardHeader({
                col: colLabel,
                language,
                colStyle: colIndex ? colStyle : null,
                isLeftAligned: !colIndex && !centerFirstCol,
                fixedHeader: (!colIndex && fixFirstColumn),
              });
            }
            return this.renderSortHeader({
              col: colLabel !== allColumns[colIndex] ? allColumns[colIndex] : colLabel,
              colLabel,
              currentSort,
              language,
              colStyle: colIndex ? colStyle : null,
              isLeftAligned: !colIndex && !centerFirstCol,
              fixedHeader: (!colIndex && fixFirstColumn),
              fittedText,
            });
          }
          return this.renderSortHeader({
            col: colLabel !== allColumns[colIndex] ? allColumns[colIndex] : colLabel,
            colLabel,
            currentSort,
            language,
            colStyle: colIndex ? colStyle : null,
            isLeftAligned: !colIndex && !centerFirstCol,
            fixedHeader: (!colIndex && fixFirstColumn),
            fittedText,
          });
        })}
      </Table.Row>
            // if (disableSort && sortFirstColumn === false) {
            //   return this.renderStandardHeader({
            //     col: colLabel,
            //     language,
            //     colStyle: colIndex ? colStyle : null,
            //     isLeftAligned: !colIndex && !centerFirstCol,
            //     fixedHeader: (!colIndex && fixFirstColumn),
            //   });
            // }
            // if (sortFirstColumn && colIndex === 0) {
            //   return this.renderSortHeader({
            //     col: colLabel !== allColumns[colIndex] ? allColumns[colIndex] : colLabel,
            //     colLabel,
            //     currentSort,
            //     language,
            //     colStyle: colIndex ? colStyle : null,
            //     isLeftAligned: !colIndex && !centerFirstCol,
            //     fixedHeader: (!colIndex && fixFirstColumn),
            //     fittedText,
            //   });
            // }


            // sortable || disableSort
            //   ? this.renderStandardHeader({
              //     col: colLabel,
              //     language,
              //     colStyle: colIndex ? colStyle : null,
              //     isLeftAligned: !colIndex && !centerFirstCol,
              //     fixedHeader: (!colIndex && fixFirstColumn),
              //   })
              //   : this.renderSortHeader({
                //     col: colLabel !== allColumns[colIndex] ? allColumns[colIndex] : colLabel,
                //     colLabel,
                //     currentSort,
                //     language,
                //     colStyle: colIndex ? colStyle : null,
                //     isLeftAligned: !colIndex && !centerFirstCol,
                //     fixedHeader: (!colIndex && fixFirstColumn),
                //     fittedText,
                //   }),
    );
  };

  renderHeaderName = ({ language, col }) => {
    if (dictionary[language][col] && dictionary[language][col].name) {
      return dictionary[language][col].name;
    }

    return col;
  };

  renderStandardHeader = ({ col, language, fixedHeader }) => {
    const { collapsed, data, toggleTeamStats, tableTitleFixed, tableStatsFixed } = this.props;
    const cellClass = classNames([classes.columnHeader], {
      [classes.collapsed]: collapsed,
    });
    return (
      toggleTeamStats === false && col === 'GMS' ? null :
      <Table.HeaderCell
        key={ShortId.generate()}
          // className={cellClass}
        className={cellClass + this.props.data ? (tableTitleFixed && tableStatsFixed ? 'tableStats--sticky' : 'tableStatsHeader--sticky') : null}
      >
        <span ref={fixedHeader ? this.addFixedElement : null}>
          {this.renderHeaderName({ language, col })}
        </span>
      </Table.HeaderCell>
    );
  };

  renderSortHeader = ({
    col,
    colLabel,
    currentSort,
    language,
    isLeftAligned,
    colStyle,
    fixedHeader,
    fittedText,
  }) => (
    <SortHeader
      key={ShortId.generate()}
      colKey={col}
      onSortChange={(colKey, dir) => this.sortRows(colKey, dir)}
      sortDir={currentSort[col]}
      isActive={Object.keys(this.state.currentSort)[0] === col}
      textAlign={isLeftAligned ? 'left' : 'center'}
      description={
        dictionary[language][col] && dictionary[language][col].description
      }
      addFixedElement={fixedHeader ? this.addFixedElement : null}
      style={colStyle}
      className={fittedText ? 'fittedText' : ''}
    >
      {col === colLabel ? this.renderHeaderName({ language, col }) : colLabel}
    </SortHeader>
  );

  renderCellData = (row, col) => {
    if (col.includes('FFPTS') && !isNaN(row[col])) {
      if (typeof (row[col]) === 'number') return <b>{row[col].toFixed(2)}</b>;
      return <b>{row[col]}</b>;
    }
    // Blank cells should have an en-dash
    // if (!row[col] && row[col] !== 0) return '\u2013'
    if (!row[col] && row[col] !== 0) return '';
    return isNaN(row[col]) || Number.isInteger(row[col])
      ? row[col].element || row[col]
      : row[col];
  };

  renderBody = () => {
    const { allColumns, rows } = this.state;
    const { collapsed, centerFirstCol, fixFirstColumn, tracking, currentFormula, selectedYear, currentSeason } = this.props;
    const cellClass = classNames({ [classes.collapsed]: collapsed });
    if (!rows.length || selectedYear > currentSeason) {
      return (
        <Table.Row>
          <Table.Cell
            colSpan={allColumns.length || 20}
            className={classes.noResults}
          >
            No data available for the current criteria.
          </Table.Cell>
        </Table.Row>
      );
    }

    // var playerIndex = 1;
    return rows.map(row => {
      const rowClass = classNames({
        evenStripe: row.stripeGroup,
        oddStripe: typeof row.stripeGroup !== 'undefined' && !row.stripeGroup,
        [classes.tracked]: tracking[row.playerId] && tracking[row.playerId].leagues.includes(currentFormula),
        [classes.noAnalysis]: tracking[row.playerId] && tracking[row.playerId].leagues.includes(currentFormula),
      });
      // if (row.player !== undefined && row.player.element && row.player.element.props && !row.player.element.props.rank) {
      //   //row['player'].element.props.rank = playerIndex++;
      // }
      return (
        <Table.Row key={ShortId.generate()} className={rowClass}>
          {allColumns.map((
            col,
            colIndex, // eslint-disable-line no-confusing-arrow
          ) => {
            // GMS Column display
            let rowSpan = 1;
            let byeCellClass = '';
            if (row[col] !== undefined && row[col] !== null) {
              rowSpan = row[col].rowSpan === undefined ? rowSpan : row[col].rowSpan;
              byeCellClass = row[col].byeCell ? 'byecell' : '';
            }
            return this.props.toggleTeamStats === false && col === 'games' ? null :
            <Table.Cell
              key={col}
              className={cellClass}
              singleLine
              textAlign={!colIndex && !centerFirstCol ? 'left' : 'center'}
              rowSpan={rowSpan}
            >
              {(!colIndex && fixFirstColumn) ? (
                <span ref={this.addFixedElement}>
                  <b>{this.renderCellData(row, col)}</b>
                </span>
                ) : (
                  <span className={byeCellClass}>{this.renderCellData(row, col)}</span>
                )}
            </Table.Cell>;
          })}
        </Table.Row>
      );
    });
  };

  render() {
    const { className, equalWidthCols, mediaType, colWidths, tableStatsFixed } = this.props;
    const isMobile = mediaType !== DESKTOP;
    const tableClass = classNames({
      [classes.tableContainer]: true,
      [className]: className,
      scrollable: isMobile,
    });
    // inserts col elements into Table with specified widths in percentages
    const setColWidths = colWidths
      ? colWidths.map(width => (
        <col key={ShortId.generate()} style={{ width: `${width}` }} />
      ))
      : null;
    return (
      <div
        //className={tableClass}
        className={(tableStatsFixed ||( tableStatsFixed === undefined)) ? `${tableClass} tableContainer--fixed` : tableClass}
        ref={element => {
          this.tableContainer = element;
        }}
        onScroll={this.handleRubberBandEffect}
      >
        <Table
          className="dataTable"
          striped
          celled
          selectable
          unstackable
          fixed={equalWidthCols}
        >
          <colgroup>{setColWidths}</colgroup>
          {this.renderColGroups()}
          <Table.Body>
            {this.renderColumnHeaders()}
            {this.renderBody()}
          </Table.Body>
        </Table>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ConnectedPlainTable);



// WEBPACK FOOTER //
// ./src/app/components/DataTable/PlainTable.js